import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";

import {
  CircularProgress,
  Dialog,
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
} from "@mui/material";

import CloseOutlined from "@mui/icons-material/CloseOutlined";
import "./TicketEscalationDialog.css";
import "../Components/Components.css";
import { agentLeader } from "../Store/Actions/AuthAction";
import { updateTicket } from "../Store/Actions/TicketAction";
import { setSocketNotification } from "../Store/Actions/CallAction";
import { TICKET_ESCALATED } from "../Store/Types/SocketTypes";

const TicketEscalationDialog = ({
  caseID,
  formData,
  handleCloseTicket,
  isOpen,
  setIsTicketEscalationDialogShown,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [listLeader, setListLeader] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [selectedLeaderID, setSelectedLeaderID] = useState("");
  const [selectedLeaderName, setSelectedLeaderName] = useState("");

  useEffect(() => {
    agentLeader()
      .then((response) => {
        if (response.status) {
          console.log("agent leader", response.data);
          setListLeader(response.data);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));
  }, []);

  const handleClose = () => {
    setIsTicketEscalationDialogShown(false);
    setRemarks("");
    setSelectedLeaderID("");
    setSelectedLeaderName("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    updateTicket({
      ...formData,
      contactid: 0,
      description: `<p>Ticket Escalated to <strong>${selectedLeaderName}</strong>!</p><p><strong>Remarks</strong>: ${remarks}</p>`,
      reqescalate: true,
    })
      .then((response) => {
        if (response.status) {
          console.log("Output historyID", response.data.historyid);

          toast.success("Ticket Escalated", {
            autoClose: 3000,
          });

          // Send notification to selected leader
          setSocketNotification({
            EventName: TICKET_ESCALATED,
            EventType: "INFO", // WARNING || INFO || ERROR
            Message: "New escalated ticket received!",
            RefNo: caseID,

            NotifyAgents: [
              {
                AgentID: selectedLeaderID,
              },
            ],
          })
            .then((response) => {
              if (response.status) {
                console.log(`Notification sent to ${selectedLeaderName}`);
              } else {
                console.log("error", response.error);
              }
            })
            .catch((err) => {
              console.log("err", err);
            });

          setIsSubmitting(false);

          // Close current ticket after success escalation
          handleCloseTicket();

          // Close this dialog
          handleClose();
        } else {
          console.log("error", response.error);

          toast.error(`Error Escalating Ticket! ${response?.error}`, {
            autoClose: 3000,
          });

          setIsSubmitting(false);
        }
      })
      .catch((err) => {
        console.log("err", err);

        toast.error(`Error Escalating Ticket! ${err}`, {
          autoClose: 3000,
        });

        setIsSubmitting(false);
      });
  };

  return (
    <Dialog
      open={isOpen}
      className="dialog ticket-escalation-dialog"
      fullWidth
      maxWidth="md"
      scroll="paper"
      onClose={handleClose}
    >
      <div className="dialog-container">
        <form method="post" onSubmit={handleSubmit}>
          <div className="dialog-content">
            <h2 className="title">Escalation</h2>

            <IconButton className="close-button" onClick={handleClose}>
              <CloseOutlined />
            </IconButton>

            <div className="text-fields">
              <TextField
                label="Escalate To"
                select
                value={selectedLeaderID}
                onChange={(e) => setSelectedLeaderID(e.target.value)}
              >
                {listLeader.map((leader) => (
                  <MenuItem
                    key={leader.AgentID}
                    value={leader.AgentID}
                    onClick={() => setSelectedLeaderName(leader.AgentName)}
                  >
                    {leader.AgentName}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                fullWidth
                label="Remarks"
                minRows={3}
                multiline
                value={remarks}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={{ cursor: "pointer" }}
                      onClick={() => setRemarks("")}
                    >
                      <Icon icon="ph:x-bold" width="26" />
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </div>
          </div>

          <section className="buttons">
            <button className="cancel" type="button" onClick={handleClose}>
              Cancel
            </button>

            <button className="confirm" disabled={isSubmitting} type="submit">
              {isSubmitting && <CircularProgress className="progress" />}
              Confirm
            </button>
          </section>
        </form>
      </div>
    </Dialog>
  );
};

export default TicketEscalationDialog;
